import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { ChangeEvent, useCallback, useMemo } from "react";
import { USPSAddressVerified } from "src/api/types";

interface Props {
  addressDetails: USPSAddressVerified;
  addressLine2: string;
  setAddressLine2: (line: string) => void;
}

const AddressDetails = ({
  addressDetails,
  addressLine2,
  setAddressLine2,
}: Props) => {
  const handleAddressLine2 = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setAddressLine2(event.target.value);
    },
    [setAddressLine2]
  );

  const warnings = useMemo(() => {
    const code32 = addressDetails.corrections.filter((c) => c.code === "32");

    if (code32.length > 0) {
      return code32.map((c) => (
        <Alert sx={{ width: 400 }} key={c.text} severity="warning">
          {c.text}
        </Alert>
      ));
    }

    return null;
  }, [addressDetails.corrections]);

  return (
    <Stack gap={2}>
      <Typography fontWeight={600}>Result:</Typography>
      <TextField
        required
        size="small"
        label="Address line 1"
        value={addressDetails.address.streetAddress}
        disabled
      />
      {warnings != null ? (
        <TextField
          required
          label="Address line 2"
          value={addressLine2}
          onChange={handleAddressLine2}
          autoFocus
        />
      ) : null}

      {warnings}

      <TextField
        required
        size="small"
        label="City"
        value={addressDetails.address.city}
        disabled
      />
      <TextField
        required
        size="small"
        label="State"
        value={addressDetails.address.state}
        disabled
      />
      <TextField
        required
        size="small"
        label="Zipcode"
        value={addressDetails.address.ZIPCode}
        disabled
      />
    </Stack>
  );
};

export default AddressDetails;
